// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"datepicker_wrapper__3AD5N","label":"datepicker_label__3zihH","slider":"datepicker_slider__3hGCf","iconWrapper":"datepicker_iconWrapper__25Ycm"};